import {
  HABERDASHERY_SHOP_KEY,
  READY_MADE_SHOP_KEY,
  TEXTILE_SHOP_KEY,
} from "../constants/shopMeta";

export const MTM_STEPS = Object.freeze({
  GARMENT: "garment",
  FABRIC: "fabric",
  FINISHING: "finishing",
  MEASUREMENTS: "measurements",
  FULFILLMENT: "fulfillment",
  REVIEW: "review",
});

export const MTM_SHOP_BY_STEP = Object.freeze({
  [MTM_STEPS.GARMENT]: READY_MADE_SHOP_KEY,
  [MTM_STEPS.FABRIC]: TEXTILE_SHOP_KEY,
  [MTM_STEPS.FINISHING]: HABERDASHERY_SHOP_KEY,
});

export const MTM_STEP_LABELS = Object.freeze({
  [MTM_STEPS.GARMENT]: "Choose design",
  [MTM_STEPS.FABRIC]: "Choose fabric",
  [MTM_STEPS.FINISHING]: "Choose finishing",
  [MTM_STEPS.MEASUREMENTS]: "Measurements",
  [MTM_STEPS.FULFILLMENT]: "Delivery",
  [MTM_STEPS.REVIEW]: "Review",
});

export function getMtmSelectionActionLabel(step = "") {
  switch (normalizeMtmStep(step)) {
    case MTM_STEPS.GARMENT:
      return "Choose this design";
    case MTM_STEPS.FABRIC:
      return "Choose this fabric";
    case MTM_STEPS.FINISHING:
      return "Add this finishing";
    default:
      return "Choose for Made To Measure";
  }
}

export function getMtmReturnStepAfterSelection(step = "") {
  switch (normalizeMtmStep(step)) {
    case MTM_STEPS.GARMENT:
      return MTM_STEPS.FABRIC;
    case MTM_STEPS.FABRIC:
      return MTM_STEPS.FINISHING;
    case MTM_STEPS.FINISHING:
      return MTM_STEPS.FINISHING;
    default:
      return MTM_STEPS.GARMENT;
  }
}

export function safeText(value = "") {
  return String(value ?? "").trim();
}

export function normalizeMtmStep(value = "") {
  const step = safeText(value).toLowerCase();

  if (step === "design") return MTM_STEPS.GARMENT;
  if (step === "textile") return MTM_STEPS.FABRIC;
  if (step === "trims" || step === "haberdashery") return MTM_STEPS.FINISHING;

  return Object.values(MTM_STEPS).includes(step) ? step : "";
}

export function getMtmShopForStep(step = "") {
  return MTM_SHOP_BY_STEP[normalizeMtmStep(step)] || "";
}

export function getMtmStepForShop(shopKey = "") {
  const key = safeText(shopKey);

  return (
    Object.entries(MTM_SHOP_BY_STEP).find(([, value]) => value === key)?.[0] ||
    ""
  );
}

export function getMtmEligibilityForStep(product = {}, step = "") {
  const shopKey = safeText(product?.shopKey).toLowerCase();
  const expectedShopKey = getMtmShopForStep(step);

  return Boolean(shopKey && expectedShopKey && shopKey === expectedShopKey);
}

export function getMtmShopUrl(step = "") {
  const normalizedStep = normalizeMtmStep(step);
  const shopKey = getMtmShopForStep(normalizedStep);

  if (!shopKey) return "/made-to-measure";

  return `/shop/${encodeURIComponent(shopKey)}?mtmStep=${encodeURIComponent(
    normalizedStep,
  )}`;
}

export function appendMtmParams(url = "", step = "") {
  const normalizedStep = normalizeMtmStep(step);

  if (!normalizedStep) return url;

  const separator = safeText(url).includes("?") ? "&" : "?";
  return `${url}${separator}mtmStep=${encodeURIComponent(normalizedStep)}`;
}
